import type { ClaimTypeResponse } from './api';

export interface ClaimTypeOption {
  label: string;
  value: number;
}

export const normalizeClaimTypeList = (list: ClaimTypeResponse): ClaimTypeOption[] => {
  if (!list) {
    return [];
  }
  return list.map((row) => ({
    label: row.claimTypeDesc,
    value: row.claimTypeKey,
  }));
};
